/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SyncDirectoryGroupsResult = {
  /**
   * Number of groups WorkOS returned across the organization's directories.
   */
  groupCount: number;
};

/** @internal */
export const SyncDirectoryGroupsResult$inboundSchema: z.ZodMiniType<
  SyncDirectoryGroupsResult,
  unknown
> = z.pipe(
  z.object({
    group_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "group_count": "groupCount",
    });
  }),
);

export function syncDirectoryGroupsResultFromJSON(
  jsonString: string,
): SafeParseResult<SyncDirectoryGroupsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SyncDirectoryGroupsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SyncDirectoryGroupsResult' from JSON`,
  );
}
